import React from 'react';
import { AlertTriangle, RefreshCcw } from 'lucide-react';
import { useSiteContent } from '@personal-portfolio/queries';
import { Button } from './button';
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from './empty';

interface PageErrorStateProps {
  onRetry: () => void;
  /** Optional icon override for the error illustration. */
  icon?: React.ReactNode;
  /** Optional specific error message rendered under the heading. */
  message?: string;
}

/**
 * Shared page-level error UI with a retry button, used by every page's
 * renderError render prop.
 */
export function PageErrorState({
  onRetry,
  icon,
  message,
}: PageErrorStateProps) {
  const { system } = useSiteContent();
  return (
    <Empty className="min-h-[400px]">
      <EmptyHeader>
        <EmptyMedia variant="icon">{icon ?? <AlertTriangle />}</EmptyMedia>
        <EmptyTitle>{system.errorTitle}</EmptyTitle>
        {message && <EmptyDescription>{message}</EmptyDescription>}
        <EmptyDescription>{system.errorBody}</EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <Button variant="outline" onClick={onRetry}>
          <RefreshCcw className="mr-1" />
          {system.retry}
        </Button>
      </EmptyContent>
    </Empty>
  );
}
